// extracted by mini-css-extract-plugin
export default {"container":"r6c1X","btn":"gRI8Z","block":"v2LVt","error":"s0tvZ","refresh":"ApT6z","wrapper":"f0Bk4"};